import { MixpanelEvent, type BlotterGroupingDefinition, type Position } from '@talos/kyoko';
import type { ExtraPositionColumns } from '../types';

export type DerivsGroupings = 'Underlying' | 'Product' | 'Expiry' | 'Market Account';
type GroupablePositionColumns = keyof Position | ExtraPositionColumns;

/** Row-group presets for the derivatives positions blotter (desktop toggles + mobile). */
export const POSITIONS_DERIVATIVES_GROUPINGS: BlotterGroupingDefinition<DerivsGroupings, GroupablePositionColumns>[] = [
  {
    key: 'Underlying',
    label: 'By Underlying',
    mobileLabel: 'Underlying',
    rowGroupColumns: ['underlying', 'AssetType'],
    mixpanelEvent: MixpanelEvent.GroupAssets,
    buttonDataTestId: 'by-asset-button',
  },
  {
    key: 'Market Account',
    label: 'By Market Account',
    mobileLabel: 'Market Acct',
    rowGroupColumns: ['MarketAccount'],
    mixpanelEvent: MixpanelEvent.GroupAccounts,
    buttonDataTestId: 'by-market-account-button',
  },
  {
    key: 'Product',
    label: 'By Product',
    mobileLabel: 'Product',
    rowGroupColumns: ['AssetType', 'underlying'],
    mixpanelEvent: MixpanelEvent.GroupProducts,
    buttonDataTestId: 'by-product-button',
  },
  {
    key: 'Expiry',
    label: 'By Expiry',
    mobileLabel: 'Expiry',
    rowGroupColumns: ['expiry', 'underlying'],
    mixpanelEvent: MixpanelEvent.GroupExpiries,
    buttonDataTestId: 'by-expiry-button',
  },
];
